/* -----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
import { Token } from '@lumino/coreutils';
/**
 * A service to connect to the settings endpoint.
 */
export const ISettingConnector = new Token('@jupyterlab/coreutils:ISettingConnector', 'A service to connect to the settings endpoint.');
/**
 * The setting registry token.
 */
export const ISettingRegistry = new Token('@jupyterlab/coreutils:ISettingRegistry', `A service for the JupyterLab settings system.
  Use this if you want to store settings for your application.
  See "schemaDir" for more information.`);
//# sourceMappingURL=tokens.js.map